import React from "react";

import Row from "./Row/";

class Rows extends React.Component {
  render() {
    const { data } = this.props;

    return data.map((row, index) => (
      <Row
        key={row.id}
        row={row}
        {...this.props}
        isLastRow={index === data.length - 1}
      />
    ));
  }
}

export default Rows;
